// extracted by mini-css-extract-plugin
module.exports = {"StepsContainer":"Steps_StepsContainer__3zclJ","packagingImg":"Steps_packagingImg__3BE3g","Step":"Steps_Step__AbZAt"};